import React, { createContext, useContext, useState } from "react";

const PaginationContext = createContext();

export const usePagination = () => useContext(PaginationContext);

export const PaginationProvider = ({ children }) => {
  const [paginationConfig, setPaginationConfig] = useState({
    page: 1,
    totalPages: 1,
    limit: process.env.REACT_APP_FETCH_LIMIT || 10,
  });

  return (
    <PaginationContext.Provider value={{ paginationConfig, setPaginationConfig }}>
      {children}
    </PaginationContext.Provider>
  );
};
